/**
 * TypeScript прав, что это readonly объекты, но слишком усложняет типизацию в местах использования
 * Считаем, что эти элементы не будем специально мутировать при работе с иммутабельным Реактом
 */
const OBJECT_EMPTY = Object.freeze({}) as unknown as typeof Object.prototype;

const ARRAY_EMPTY = Object.freeze([]) as unknown as typeof Array.prototype;

const FUNCTION_EMPTY = Object.freeze(() => {}) as unknown as typeof Function.prototype;

export { OBJECT_EMPTY, ARRAY_EMPTY, FUNCTION_EMPTY };
